import { FC, ReactNode } from 'react';
import { Container } from 'react-bootstrap';

export interface BaseTemplateProps {
  children: ReactNode;
}

const BaseTemplate: FC<BaseTemplateProps> = ({ children }) => {
  return <Container>{children}</Container>;
};

export default BaseTemplate;
